import { render, staticRenderFns } from "./GetChooseItem.vue?vue&type=template&id=0e18ee4a&"
import script from "./GetChooseItem.vue?vue&type=script&lang=js&"
export * from "./GetChooseItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports